// ===================================================
// frontend/src/components/Planning/PlanningStats.js
// WITH CORE KPI CARDS ONLY (no warehouse breakdown)
// + Display Date Range (1 Oct 2025 → Today)
// ===================================================
import React from 'react';

const PlanningStats = ({ stats, loading }) => {
  console.log("📊 [PlanningStats] stats received:", stats);

  const safeStats = stats || {};
  if (loading) return <div>Loading...</div>;

  // 📅 Build readable date range
  const startDate = "1 Oct 2025";
  const today = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return (
    <div>
      {/* 🗓️ Date Range Line */}
      <div style={dateRange}>
        📆 From <strong>{startDate}</strong> to <strong>{today}</strong>
      </div>

      {/* ===== Row 1: Core KPIs ===== */}
      <div style={grid}>
        <Card title="Total Sales" color="#16a34a" value={safeStats.totalSales} />
        <Card title="Total Manufacturing" color="#d97706" value={safeStats.totalManufacturing} />
        <Card title="Current Total Stock" color="#059669" value={safeStats.latestStock} />
        <Card
          title="Average Delta"
          color={safeStats.averageDelta >= 0 ? '#16a34a' : '#dc2626'}
          value={safeStats.averageDelta}
        />
      </div>
    </div>
  );
};

// 🔹 Simple KPI Card
const Card = ({ title, color, value, date, bg }) => (
  <div style={{ ...card, background: bg || 'white' }}>
    <div style={{ ...big, color }}>{(value ?? 0).toLocaleString()}</div>
    <div style={label}>{title}</div>
    {date && <div style={dateStyle}>📅 {date}</div>}
  </div>
);

// ===== Styles =====
const dateRange = {
  textAlign: "center",
  fontSize: "0.9rem",
  color: "#4b5563",
  marginBottom: "0.75rem",
  fontWeight: 500,
};

const grid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
  gap: '1rem',
  marginBottom: '1.5rem',
};

const card = {
  background: 'white',
  padding: '1rem',
  borderRadius: 8,
  border: '1px solid #e5e7eb',
  textAlign: 'center',
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
};
const label = { fontSize: '0.875rem', color: '#6b7280' };
const big = { fontSize: '1.5rem', fontWeight: 'bold' };
const dateStyle = { fontSize: '0.8rem', color: '#6b7280', marginTop: '0.25rem' };

export default PlanningStats;
